import './main.css';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { initTelemetry } from '@repo/features/telemetry';

import { App } from './app/app';

const connectionString = import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING;
if (connectionString) {
  initTelemetry({ connectionString, appName: 'cv-public' });
}

const rootElement = document.getElementById('root');

if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
